<template>
  <div class="tech-audio">
      <div
        v-for="(audio, index) in audios"
        :key="index"
        style="border-bottom: 1px solid #eee; padding: 1rem 1rem;"
      >
        {{ audio.titel}} <br>
        {{ audio['video_self'] }} <br>

        <p>
          <span
            style="cursor: pointer; color: blue; text-decoration: underline;"
          >
            <a :href="boltLink(audio.id)" target="_blank" >in Bolt bearbeiten ...</a>
          </span>
        </p>
        <audio controls>
          <source :src="audio['video_self']" type="audio/mpeg">
        </audio>
      </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      allMedia: 'getAllMediaObjectsData'
    }),
    audios () {
      return [...this.allMedia].filter(m => {
        return m['rubrik_sammlung'] === 'Audios'
      })
    }
  },
  methods: {
    boltLink (id) {
      return 'https://bolt-dev.dh-north.org/bolt/editcontent/medienobjekte/' + id + '#medien'
    }
  }
}
</script>
